/** @format */

import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import type { SxProps } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { ReceiptIcon } from "@phosphor-icons/react/dist/ssr/Receipt";
import { formatCurrency } from "../../../utility/currencyUtils";

export interface TotalProfitProps {
	sx?: SxProps;
	value: number;
}

export function CirclesTotalPayoutsForCurrentMonth({
	value,
	sx,
}: TotalProfitProps): React.JSX.Element {
	return (
		<Card sx={sx}>
			<CardContent>
				<Stack
					direction="row"
					sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
					spacing={3}>
					<Stack spacing={1}>
						<Typography color="text.secondary" variant="overline">
							Monthly Payouts
						</Typography>
						<Typography variant="h4">{formatCurrency(value, "usd")}</Typography>
					</Stack>
					<Avatar
						sx={{
							backgroundColor: "primary.main",
							height: "56px",
							width: "56px",
						}}>
						<ReceiptIcon size={24} color="#ffffff" />
					</Avatar>
				</Stack>
			</CardContent>
		</Card>
	);
}
